export default {
  title: 'タイトル',
  image: '画像',
  description: '説明',
  url: 'URL',
};
